// extracted by mini-css-extract-plugin
var _1 = "customButton__osqGw";
export { _1 as "customButton" }
export default { "customButton": _1 }
